import { defineMessages } from 'react-intl';

export default defineMessages({
  orContinueWith: {
    id: 'login.sso.orContinueWith',
    defaultMessage: 'Or continue with',
  },
  continueWith: {
    id: 'login.sso.continueWith',
    defaultMessage: 'Continue with {provider}',
  },
  signUpWith: {
    id: 'login.sso.signUpWith',
    defaultMessage: 'Sign up with {provider}',
  },
  workAccountHint: {
    id: 'login.sso.workAccountHint',
    defaultMessage: 'Use your work account.',
  },
});
